import axios from "./request"

export default {
  async create(data) {
    return (await axios.post('/technical-managers', data)).data
  }
}
